export default __webpack_public_path__ + "static/media/item_2.90c5a27d.webp";